import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var _a;
var PREFIX = "NoResult";
var classes = {
    container: "".concat(PREFIX, "-container")
};
var StyledNoResult = styled(Box)((_a = {},
    _a["&.".concat(classes.container)] = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%"
    },
    _a));

export { classes, StyledNoResult as default };
//# sourceMappingURL=index.styled.js.map
